import React from "react";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import { Doughnut } from "react-chartjs-2";
import { MoreVertical } from "react-feather";

import { orange, green, red, blue } from "@mui/material/colors";
import {
  Card as MuiCard,
  CardContent,
  CardHeader,
  IconButton,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableHead,
  TableRow as MuiTableRow,
  Typography,
} from "@mui/material";
import { spacing } from "@mui/system";
import { border } from "polished";

const Card = styled(MuiCard)(spacing);

const ChartWrapper = styled.div`
  height: 168px;
  position: relative;
`;

const DoughnutInner = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -22px;
  text-align: center;
  z-index: 0;
`;

const TableRow = styled(MuiTableRow)`
  height: 42px;
`;

const TableCell = styled(MuiTableCell)`
  padding-top: 0;
  padding-bottom: 0;
`;

const GreenText = styled.span`
  color: ${() => green[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const RedText = styled.span`
  color: ${() => red[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const BlueText = styled.span`
  color: ${() => blue[400]};
  font-weight: ${(props) => props.theme.typography.fontWeightMedium};
`;

const SessionsByTypeWebConnect = ({ theme }) => {
  const data = {
    labels: ["Chat", "Audio", "Video"],
    datasets: [
      {
        data: [260, 125, 78],
        backgroundColor: [green[500], red[500], blue[500]],
        borderWidth: 5,
        borderColor: theme.palette.background.paper,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    cutout: "80%",
  };

  return (
    <Card mb={6} style={{ height: "400px" }}>
      <CardHeader
        action={
          <IconButton aria-label="settings" size="large">
            <MoreVertical />
          </IconButton>
        }
        title="Sessions By Type (Web Connect)"
      />

      <CardContent>
        <ChartWrapper>
          <DoughnutInner>
            <Typography variant="caption">Total</Typography>
            <Typography variant="h4">2</Typography>
          </DoughnutInner>
          <Doughnut data={data} options={options} />
        </ChartWrapper>
        <Table>
          {/* <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Count</TableCell>
            </TableRow>
          </TableHead> */}
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" style={{ borderBottom: 0 }}>
                Chat
              </TableCell>
              <TableCell align="right" style={{ borderBottom: 0 }}>
                <GreenText>12</GreenText>
              </TableCell>
              {/* <TableCell align="right">
                <GreenText>+35%</GreenText>
              </TableCell> */}
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" style={{ borderBottom: 0 }}>
                Audio
              </TableCell>
              {/* <TableCell align="right">125</TableCell> */}
              <TableCell align="right" style={{ borderBottom: 0 }}>
                <RedText>12</RedText>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" style={{ borderBottom: 0 }}>
                Video
              </TableCell>
              {/* <TableCell align="right">54</TableCell> */}
              <TableCell align="right" style={{ borderBottom: 0 }}>
                <BlueText>46</BlueText>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default withTheme(SessionsByTypeWebConnect);
